import React from "react";
// UI Framework
import AddIcon from "@mui/icons-material/Add";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { Modal } from "src/Components";
// Local Components
import CashFlowTable from "./CashFlowTable";
// Services
import { getPaymentTable } from "src/Requests/imePortfolio";
// Types
import {
  IUserPositionSummarySearchParams,
  IUserPositionSummaryTableReport,
} from "src/Interfaces/imePortfolio";
import PortfoTableSection from "./PortfoTableSection";

interface IProps {
  searchParams: IUserPositionSummarySearchParams;
  refreshFlag: boolean;
  setRefresh: (flag: boolean) => void;
  totalRefreshFlag: boolean;
}

const PaymentTable = ({ searchParams, refreshFlag, setRefresh, totalRefreshFlag }: IProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <PortfoTableSection
      title="واریز و برداشت وجه"
      action={
        <div
          className={`flex items-center justify-center transition-all w-5 h-5 rounded-full ${searchParams.userId ? "hover:bg-green-600 bg-green-700 cursor-pointer" : "bg-gray-500 cursor-not-allowed"}`}
          onClick={() => {
            if (!searchParams.userId) return;
            setIsModalOpen(true);
          }}
        >
          <AddIcon fontSize="small" className="text-white transition-all" />
        </div>
      }
    >
      {isModalOpen ? (
        <Modal
          UI={
            <CashFlowTable
              searchParams={searchParams}
              setRefresh={setRefresh}
            />
          }
          onClose={() => setIsModalOpen(false)}
          modalBoxClassName="!w-[500px] !min-w-[500px] !min-h-[500px] !overflow-visible [&_.modal-UI]:!overflow-visible"
        />
      ) : null}

      <TableTemplate<
        IUserPositionSummarySearchParams,
        IUserPositionSummaryTableReport
      >
        getDataTable={getPaymentTable}
        tableWrapperClassname="w-full justify-start"
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            sortingType={sortingType}
            setSortingType={setSortingType}
            tableBoxClassName="!mx-0"
            tableHeaderClassName="!bg-sky-50 hover:!bg-sky-100"
            onAction={onAction}
            refreshFlag={refreshFlag || totalRefreshFlag}
          />
        )}
        withSort
        searchParameters={searchParams}
      />
    </PortfoTableSection>
  );
};

export default PaymentTable;
